import React from 'react';

import { PostsContext, PostsContextValue } from './PostsContext';

/** @deprecated Change the struture of the code and use `HomeFeedCard` instead. */
export const PostsProvider: React.FC<PostsContextValue> = ({ children, ...value }) => {
  return <PostsContext.Provider value={value}>{children}</PostsContext.Provider>;
};
